import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Youtube, Facebook, Mail, Phone } from 'lucide-react';
import { contactInfo } from '../data/mock';

export const Footer = () => {
  return (
    <footer className="bg-maroon text-ivory py-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src="/assets/logo.png" alt="Nrityavilasini Dance Academy" className="h-14 w-14 object-contain" data-testid="footer-logo" />
              <h3 className="text-xl font-bold text-gold">Nrityavilasini Dance Academy</h3>
            </div>
            <p className="text-sm leading-relaxed opacity-90">
              Preserving the sacred art of Bharatanatyam through dedication, devotion, and disciplined practice.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-gold">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="hover:text-gold transition-colors duration-200">
                  About the Artist
                </Link>
              </li>
              <li>
                <Link to="/performances" className="hover:text-gold transition-colors duration-200">
                  Performance Videos
                </Link>
              </li>
              <li>
                <Link to="/classes" className="hover:text-gold transition-colors duration-200">
                  Classes & Schedule
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-gold transition-colors duration-200">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Social */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-gold">Connect</h4>
            <div className="space-y-3 text-sm mb-4">
              <div className="flex items-center space-x-2">
                <Mail size={16} className="text-gold" />
                <a href={`mailto:${contactInfo.email}`} className="hover:text-gold transition-colors duration-200">
                  {contactInfo.email}
                </a>
              </div>
              <div className="flex items-center space-x-2">
                <Phone size={16} className="text-gold" />
                <a href={`tel:${contactInfo.phone}`} className="hover:text-gold transition-colors duration-200">
                  {contactInfo.phone}
                </a>
              </div>
            </div>
            <div className="flex space-x-4">
              <a
                href={contactInfo.socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="text-ivory hover:text-gold transition-colors duration-200"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href={contactInfo.socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="text-ivory hover:text-gold transition-colors duration-200"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
              <a
                href={contactInfo.socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="text-ivory hover:text-gold transition-colors duration-200"
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gold opacity-30 mt-8 pt-6 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Digjaya Ghaisas. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
